import type { PayrollRosterMember, PayrollTeam } from "@/payroll/roster/types";

export const normalizeTeamIds = (ids: readonly string[]) =>
  Array.from(new Set(ids)).sort();
export const validTeamIds = (
  ids: readonly string[],
  teams: readonly PayrollTeam[],
) => normalizeTeamIds(ids.filter((id) => teams.some((team) => team.id === id)));
export const teamFilterParams = (ids: readonly string[]) =>
  ids.length ? { team_access_key_ids: normalizeTeamIds(ids) } : {};
export const rosterTeamNames = (
  member: PayrollRosterMember,
  teams: readonly PayrollTeam[] = [],
) =>
  (member.team_access_key_ids ?? [])
    .map(
      (id) =>
        teams.find((team) => team.id === id)?.name ??
        member.team_access_keys?.find((team) => team.id === id)?.name,
    )
    .filter((name): name is string => !!name)
    .join(", ");
export const sameTeamIds = (
  a: readonly string[] = [],
  b: readonly string[] = [],
) =>
  JSON.stringify(normalizeTeamIds(a)) === JSON.stringify(normalizeTeamIds(b));

/** Keep saved names for assigned teams that are no longer active. */
export const rosterTeamSnapshots = (
  ids: readonly string[],
  teams: readonly PayrollTeam[],
  saved: readonly PayrollTeam[] = [],
): PayrollTeam[] => {
  const byId = new Map([...saved, ...teams].map((team) => [team.id, team]));
  return ids.flatMap((id) => {
    const team = byId.get(id);
    return team ? [team] : [];
  });
};
